// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__2CqGJ","Icons":"Contact_Icons__1wamW","Mail":"Contact_Mail__3Y-bL"};